export default __webpack_public_path__ + "static/media/4-step.6bf69cb3.png";